import {
	AttributeOption,
	CountReply,
	NamespacedStoreState,
	UnitMetadata,
} from '@Types';
import { createSelector } from '@reduxjs/toolkit';
import { moduleNamespace } from '@Store/config.store';
import { useSelector } from 'react-redux';

const parseNamespace = (state: NamespacedStoreState) => state[moduleNamespace];

const RiskStoreSelector = createSelector(
	parseNamespace,
	state => state.RiskStore,
);

const IsCountLoadingSelector = createSelector(
	RiskStoreSelector,
	state => state.isCountLoading,
);

const CountStoreSelector = createSelector(
	RiskStoreSelector,
	state => state.count,
);

export const selectorIsCountLoading = (key: string) => {
	return createSelector(IsCountLoadingSelector, state => {
		return state.indexOf(key) !== -1;
	});
};

const selectorCount = (key: string) => {
	return createSelector(CountStoreSelector, state => {
		if (state) {
			return state[key];
		}
	});
};

export const IsMetadataLoadingSelector = createSelector(
	RiskStoreSelector,
	state => state.isMetadataLoading,
);

export const selectorIsAnyMetadataLoadingSelector = createSelector(
	RiskStoreSelector,
	state => state.isMetadataLoading.length !== 0,
);

export const UnitMetadataStoreSelector = createSelector(
	RiskStoreSelector,
	state => state.unitMetadata,
);

export const AttributesStoreSelector = createSelector(
	RiskStoreSelector,
	state => state.attributes,
);

export const selectorIsMetadataLoading = (key: string) => {
	return createSelector(IsCountLoadingSelector, state => {
		return state.indexOf(key) !== -1;
	});
};

const selectorUnitMatadata = (key: string) => {
	return createSelector(UnitMetadataStoreSelector, state => {
		if (state) {
			return state[key];
		}
	});
};

export const selectIsCountLoading = (key: string) =>
	useSelector(selectorIsCountLoading(key));

export const selectCount = (key: string): CountReply[] | undefined =>
	useSelector(selectorCount(key));

export const selectIsAnyMetadataLoading = () =>
	useSelector(selectorIsAnyMetadataLoadingSelector);

export const selectIsMetadataLoading = (key: string) =>
	useSelector(selectorIsMetadataLoading(key));

export const selectAllUnitMatadata = (): {
	[key: string]: UnitMetadata | undefined;
} => useSelector(UnitMetadataStoreSelector);

export const selectUnitMatadata = (key: string): UnitMetadata | undefined =>
	useSelector(selectorUnitMatadata(key));

export const selectAttributes = (): AttributeOption[] =>
	useSelector(AttributesStoreSelector);

const AttributeDataGridSelector = createSelector(
	RiskStoreSelector,
	state => state.attributeDataGrid,
);

const AttributeRangeValuesSelector = createSelector(
	RiskStoreSelector,
	state => state.attributeRangeValues,
);

const AttributeRangeUnitValuesSelector = createSelector(
	RiskStoreSelector,
	state => state.attributeRangeUnitValues,
);

export const selectAttributeDataGrid = () =>
	useSelector(AttributeDataGridSelector);

export const selectAttributeRangeValues = () =>
	useSelector(AttributeRangeValuesSelector);

export const selectAttributeRangeUnitValues = () =>
	useSelector(AttributeRangeUnitValuesSelector);
